import { format } from 'date-fns';
import { ConsiderationType } from 'further-types/exit';
import { ExitDetailsFormValues } from '../../ExitDetailsForm';
import { StagedShareholding } from '../../ExitDetailsForm/types';

type SharedShareConsiderationFields = {
  shareConsiderationCompanyId?: string;
  shareConsiderationShareClassId?: string;
  totalConsiderationShares?: number;
  shareConsiderationValuePerShare?: number;
  shareConsiderationValueTotal?: number;
  shareConsiderationEisEligible?: boolean;
  shareConsiderationAllocationMethod?: string;
  permitPartialShareAllocation?: boolean;
};

export type StageCorrectionForOriginalInput = {
  exitId: string;
  exitDate: string;
  firmId: string;
  companyIds: Array<string>;
  sharesToBeSold: number;
  sharePrice: number;
  taxableValueSharePrice: number;
  shareAllocationUploadIds: Array<string>;
  considerationType: string;
  maintainOriginalExitDetails?: boolean;
} & SharedShareConsiderationFields;

export type Mutation = {
  mutate: (
    data: StageCorrectionForOriginalInput,
    options: {
      onSuccess: (data: Array<StagedShareholding>) => void;
    },
  ) => void;
};

export const stageCorrectionForOriginal = (
  mutation: Mutation,
  exitId: string,
  exitDetails: ExitDetailsFormValues,
  sharedShareConsiderationFields: SharedShareConsiderationFields,
  maintainOriginalExitDetails: boolean | undefined,
  setInitialShareholdings: (data: Array<StagedShareholding>) => void,
) => {
  mutation.mutate(
    {
      exitId,
      exitDate: format(exitDetails.exitDate, 'dd/MM/yyyy'),
      companyIds: exitDetails.selectedShareClasses ?? [],
      firmId: exitDetails.firmId,
      sharePrice: Number(exitDetails.sharePrice),
      taxableValueSharePrice: Number(exitDetails.taxableValueSharePrice),
      sharesToBeSold: exitDetails.sharesToBeSold,
      shareAllocationUploadIds: exitDetails.selectedAllocations ?? [],
      considerationType:
        exitDetails.considerationType ?? ConsiderationType.Cash,
      ...sharedShareConsiderationFields,
      ...(maintainOriginalExitDetails !== undefined
        ? { maintainOriginalExitDetails }
        : {}),
    },
    {
      onSuccess: (data: Array<StagedShareholding>) => {
        const formattedInitialShareholdingData: Array<StagedShareholding> = (
          data ?? []
        ).map((sh) => ({
          ...sh,
          suggestedSharesAllocatedForSale: sh.sharesAllocatedForSale ?? 0,
          // Do NOT override investorTotalAccruedFees from the backend response
          // It contains the investment-level max that should be shown as the limit for all shareholdings
        }));
        setInitialShareholdings(formattedInitialShareholdingData);
      },
    },
  );
};
